const required = (name: string, value: string | undefined) => {
  if (!value) throw new Error(`Variable manquante : ${name} (voir .env.example)`);
  return value;
};

/**
 * Développement sur un téléphone par le Wi-Fi (pnpm dev:wifi) : la page est ouverte sur l'adresse du poste,
 * donc « 127.0.0.1 » désignerait le téléphone. On vise alors le même hôte que la page. Sans effet en production.
 */
const onLan = (url: string) =>
  import.meta.env.DEV && !["localhost", "127.0.0.1"].includes(window.location.hostname)
    ? url.replace(/\/\/(127\.0\.0\.1|localhost)(?=[:/]|$)/, `//${window.location.hostname}`)
    : url;

export const env = {
  supabaseUrl: onLan(required("VITE_SUPABASE_URL", import.meta.env.VITE_SUPABASE_URL)),
  supabaseAnonKey: required("VITE_SUPABASE_ANON_KEY", import.meta.env.VITE_SUPABASE_ANON_KEY),
  apiUrl: onLan(import.meta.env.VITE_API_URL ?? "http://127.0.0.1:8080"),
  vapidPublicKey: import.meta.env.VITE_VAPID_PUBLIC_KEY as string | undefined,
  /**
   * Adresse publique des médias (R2_PUBLIC_BASE_URL côté API). En développement, sans réglage,
   * c'est le bucket « media-public » du stockage Supabase local : voir docs/runbooks/03_medias-en-local.md.
   */
  mediaBaseUrl:
    (import.meta.env.VITE_MEDIA_BASE_URL as string | undefined) ??
    (import.meta.env.DEV
      ? `${onLan(import.meta.env.VITE_SUPABASE_URL ?? "")}/storage/v1/object/public/media-public`
      : undefined),
};
